import GlobalMap from "./GlobalMap";
import { useContext, useEffect, useState } from "react";
import { intelliegenceContext } from "../../states/context/intelliegenceContext";
import { getGlobalRisksData } from "../../services/api.service";
import SearchBarContainer from "./side-bar/SearchBarContainer";
import NavBar from "./NavBar";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import MuiListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import { NavLink } from "reactstrap";
import Logo from "../../assets/images/kavida-logo.png";
import { Button, Typography } from "@material-ui/core";
import Sendinlue from "./Sendinlue";
import SideBar from "./side-bar/SideBar";
const calendly_url = process.env.REACT_APP_CALENDLY_URL;

const portSupplierMarkers = [
  //   {
  //   "item_id": "BDCGP",
  //   "lat": 22.273,
  //   "lng": 91.832,
  //   "marker_type": "port",
  //   "color": "port",
  //   "marker_priority": 1,
  //   "data": {
  //       "port_name": "Chattogram",
  //       "country": "Bangladesh",
  //       "berth": {
  //           "time_stamp": "2.00 Days", //2.00 Days, 0.90, 16 Vessels
  //           "info": ""
  //       },
  //       "port": {
  //           "time_stamp": "0.90 Days",
  //           "info": ""
  //       },
  //       "export_dwell_time_stamp": "4.33 days",
  //       "import_dwell_time_stamp": "1.59 days"
  //   }
  // },
  // {
  //   "item_id": "INCCU",
  //   "lat": 22.55628,
  //   "lng": 88.30498,
  //   "marker_type": "port",
  //   "color": "port",
  //   "marker_priority": 1,
  //   "data": {
  //       "port_name": "Kolkata",
  //       "country": "India",
  //       "berth": {
  //           "time_stamp": "No Data Available",
  //           "info": "No Data Available"
  //       },
  //       "port": {
  //           "time_stamp": "No Data Available",
  //           "info": "No Data Available"
  //       },
  //       "export_dwell_time_stamp": "No Data Available",
  //       "import_dwell_time_stamp": "No Data Available"
  //   }
  // },
  // {
  //   "item_id": "HKHKG",
  //   "lat": 22.287945,
  //   "lng": 114.18135,
  //   "marker_type": "port",
  //   "color": "port",
  //   "marker_priority": 1,
  //   "data": {
  //       "port_name": "Hong Kong",
  //       "country": "Hong Kong",
  //       "berth": {
  //           "time_stamp": "No Data Available",
  //           "info": "No Data Available"
  //       },
  //       "port": {
  //           "time_stamp": "No Data Available",
  //           "info": "No Data Available"
  //       },
  //       "export_dwell_time_stamp": "No Data Available",
  //       "import_dwell_time_stamp": "1 day(s) and 21 hour(s)"
  //   }
  // },
  // {
  //   "item_id": "CNSHA",
  //   "lat": 31.3663,
  //   "lng": 121.614,
  //   "marker_type": "port",
  //   "color": "port",
  //   "marker_priority": 1,
  //   "data": {
  //       "port_name": "Shanghai",
  //       "country": "China",
  //       "berth": {
  //           "time_stamp": "No Data Available",
  //           "info": "No Data Available"
  //       },
  //       "port": {
  //           "time_stamp": "No Data Available",
  //           "info": "No Data Available"
  //       },
  //       "export_dwell_time_stamp": "3 day(s) and 19 hour(s)",
  //       "import_dwell_time_stamp": "4 day(s) and 0 hour(s)"
  //   }
  // },
  // {
  //   "item_id": "LKCMB",
  //   "lat": 6.96775,
  //   "lng": 79.84391,
  //   "marker_type": "port",
  //   "color": "port",
  //   "marker_priority": 1,
  //   "data": {
  //       "port_name": "Colombo",
  //       "country": "Sri Lanka",
  //       "berth": {
  //           "time_stamp": "No Data Available",
  //           "info": "No Data Available"
  //       },
  //       "port": {
  //           "time_stamp": "No Data Available",
  //           "info": "No Data Available"
  //       },
  //       "export_dwell_time_stamp": "No Data Available",
  //       "import_dwell_time_stamp": "No Data Available"
  //   }
  // },
  // {
  //   "item_id": "6112ee07b6bd3bbdade1ecc2",
  //   "color": "green",
  //   "marker_type": "supplier",
  //   "lat": 23.8673451,
  //   "lng": 90.4389076,
  //   "tier_level": "1",
  //   "data": {
  //       "supplier_name": "Aman Fashions & Designs Ltd",
  //       "address": "Bangabandhu Road, Tongabari, Ashulia, Savar, 1340, Dhaka",
  //       "risk": 0
  //   },
  //   "marker_priority": 1
  // },
  // {
  //   "item_id": "6112ee07b6bd3bbdade1ecc1",
  //   "color": "green",
  //   "marker_type": "supplier",
  //   "lat": 31.309044,
  //   "lng": 121.2786619,
  //   "tier_level": "1",
  //   "data": {
  //       "supplier_name": "ASI GLOBAL LIMITED",
  //       "address": "No.1228 Huiping Road Nanxiang, Jiading Shanghai, 201802, Shanghai",
  //       "risk": 0
  //   },
  //   "marker_priority": 1
  // },
  // {
  //   "item_id": "627cd708475a02e2c9243432",
  //   "color": "green",
  //   "marker_type": "supplier",
  //   "lat": 31.22222000000005,
  //   "lng": 121.45806000000005,
  //   "tier_level": "1",
  //   "data": {
  //       "supplier_name": "Shanghai Co. LTD",
  //       "address": "No.1228 Huiping Road Nanxiang, Jiading Shanghai, 201802, Shanghai",
  //       "risk": 0
  //   },
  //   "marker_priority": 1
  // },
  // {
  //   "item_id": "6112ee07b6bd3bbdade1ecbf",
  //   "color": "green",
  //   "marker_type": "supplier",
  //   "lat": 22.876123,
  //   "lng": 72.402121,
  //   "tier_level": "1",
  //   "data": {
  //       "supplier_name": "ARVIND LIMITED",
  //       "address": "Sarkhej-Bavla Rd, Bavla, Gujarat 382220, India",
  //       "risk": 0
  //   },
  //   "marker_priority": 1
  // },
  // {
  //   "item_id": "6112ee07b6bd3bbdade1ecc0",
  //   "color": "green",
  //   "marker_type": "supplier",
  //   "lat": 28.6209681,
  //   "lng": 77.3811702,
  //   "tier_level": "1",
  //   "data": {
  //       "supplier_name": "PARAMOUNT PRODUCTS PVT LTD",
  //       "address": "E-16, Sector 63, Noida, Uttar Pradesh, India",
  //       "risk": 0
  //   },
  //   "marker_priority": 1
  // },
];

const GlobalRisks = () => {
  const context = useContext(intelliegenceContext);
  const [mapDetails, setMapDetails] = useState(null);
  const [location, setLocation] = useState("");
  const [type, setType] = useState("");
  const [category, setCategory] = useState("all");
  useEffect(() => {
    updateMap();
  }, [location, category]);

  const onChangeLocationHandler = (value) => {
    setLocation(value);
  };

  const onChangeCategoryHandler = (event) => {
    setCategory(event.target.value);
  };
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const updateMap = () => {
    const payload = {
      api_name: "public_risk_marker",
      data: {
        location: location,
        location_type: type,
        category: category,
        start_date: "2023-10-01T00:00:00",
        end_date: tomorrow.toISOString().split(".")[0],
      },
    };
    getGlobalRisksData(payload).then(
      (data) => {
        if (data && data.data && data.data.marker_location.length > 0) {
          setMapDetails((prev) => data.data);
          context.setMapLocation(data.data.map_location);
          context.setMarkerLocation([
            ...data.data.marker_location,
            ...portSupplierMarkers,
          ]);
        } else {
          const url = "https://calendly.com/anamrahman/15min";
          window.open(url, "_blank", "noopener,noreferrer");
        }
      },
      (err) => {
        console.error("err", err);
      }
    );
  };

  const ListItem = withStyles({
    root: {
      "&$selected": {
        // backgroundColor: "#1E2E54",
        backgroundColor: "#EFEFFE",
        color: "white",
        "& .MuiListItemIcon-root": {
          color: "white",
        },
      },
      "&$selected:hover": {
        backgroundColor: "#EFEFFE",
        color: "white",
        "& .MuiListItemIcon-root": {
          color: "white",
        },
      },
      "&:hover": {
        backgroundColor: "#EFEFFE",
        color: "#A4A6B3",
        "& .MuiListItemIcon-root": {
          color: "#A4A6B3",
        },
      },
    },
    selected: {},
  })(MuiListItem);

  const classes = useStyles();
  return (
    <>
      <Drawer
        className={"drawer-container"}
        variant="permanent"
        anchor="left"
      >
        <div className={classes.toolbar} />
        <div>
          <div className="header-container">
            <a href="https://www.kavida.ai/" target="_blank">
              <img width={150} src={Logo} alt={"logoImg"} />
            </a>
          </div>
          <List key="1">
            <NavLink
              className={`${classes.list}`}
              style={{
                fontFamily: "Inter",
                fontWeight: 300,
                textDecoration: "none",
                color: "#A4A6B3",
                fontSize: "12px",
                display: "flex",
                flexDirection: "row",
                padding: "2px 10px",
              }}
            >
              <ListItem button selected={true}>
                <ListItemIcon>
                  <i
                    style={{
                      color: "#9FA2B4",
                      fontSize: "18px",
                      marginLeft: "10px",
                    }}
                    className="fa-solid fa-globe"
                  />
                </ListItemIcon>
                <ListItemText
                  style={{ color: "#6361EE" }}
                  primary={"Global Risks"}
                />
              </ListItem>
            </NavLink>
          </List>
          {/* <List key="2">
            <NavLink
             rel="noopener noreferrer"
             href={process.env.REACT_APP_PUBLIC_SUPPLIER_RISK_URL}
             target="_blank"
              className={`${classes.list}`}
              style={{
                fontFamily: "Inter",
                fontWeight: 300,
                textDecoration: "none",
                color: "#A4A6B3",
                fontSize: "12px",
                display: "flex",
                flexDirection: "row",
                padding: "2px 10px",
              }}
            >
              <ListItem button>
                <ListItemIcon>
                  <i
                    style={{
                      color: "#9FA2B4",
                      fontSize: "18px",
                      marginLeft: "10px",
                    }}
                    className="fa-solid fa-globe"
                  />
                </ListItemIcon>
                <ListItemText primary={"Supplier Risks"} />
              </ListItem>
            </NavLink>
          </List> */}
          <div className={classes.ctaButtonContainer}>
            <p className={classes.ctaText}>
              Build a customised dashboard that gives you access to relevant and
              real time information affecting your suppliers.
            </p>
            <Button
              className={classes.ctaButton}
              onClick={() => {
                window.open(calendly_url, "_blank");
              }}
              variant="outlined"
              size="medium"
              color="primary"
            >
              Schedule a Demo
            </Button>
          </div>
        </div>
      </Drawer>
      <div className="body-container">
        {/* <Sendinlue /> */}
        <div className="navbar-container">
          <NavBar />
        </div>
        <div id="intelliegence">
          <SideBar />
          {/* <div>
            <SearchBarContainer
              location={location}
              category={category}
              onChangeLocationHandler={onChangeLocationHandler}
              onChangeCategoryHandler={onChangeCategoryHandler}
              setLocationType={(param) => {
                setType(param);
              }}
            />
          </div> */}
          <GlobalMap context={context} />
        </div>
        <Button
          className={`${classes.ctaButton} cta-mobile`}
          onClick={() => {
            window.open(calendly_url, "_blank");
          }}
          variant="outlined"
          size="medium"
          color="primary"
        >
          Schedule a Demo
        </Button>
      </div>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  list: {
    "&:hover": {
      color: "#d9d9d9",
      cursor: "pointer",
    },
  },
  toolbar: {
    minHeight: "8px",
  },
  ctaButtonContainer: {
    position: "absolute",
    bottom: "0",
    padding: "4%",
  },
  ctaButton: {
    background:
      "transparent linear-gradient(323deg, #9F88FF 0%, #1999A3 100%) 0% 0% no-repeat padding-box",
    borderRadius: "8px",
    textTransform: "none",
    color: "white",
    width: "100%",
    "&:hover": {
      cursor: "pointer",
    },
  },
  ctaText: {
    fontSize: "14px",
    fontFamily: "Inter",
    margin: "0",
    marginBottom: "5px",
    color: "#7F7D94",
    padding: "5px",
  },
}));

export default GlobalRisks;
